import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import Logo from "@/components/Logo";
import { toast } from "sonner";
import { Mail, KeyRound, CheckCircle2, ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Reset() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);

  const request = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/reset/request`, { email });
      if (res.data.token) { setToken(res.data.token); toast.success("Lien généré (mode démo)"); setStep(2); }
      else toast.success("Si l'email existe, un lien a été envoyé.");
    } catch { toast.error("Erreur"); } finally { setLoading(false); }
  };
  const confirm = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await axios.post(`${API}/auth/reset/confirm`, { token, new_password: pwd });
      toast.success("Mot de passe mis à jour"); setStep(3);
    } catch (err) { toast.error(err.response?.data?.detail || "Erreur"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 relative overflow-hidden" data-testid="reset-page">
      <div className="aurora opacity-50" />
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="relative w-full max-w-sm space-y-6 fade-up">
        <Link to="/"><Logo size={22} /></Link>
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-primary/15 to-violet-500/15 flex items-center justify-center ring-1 ring-border">
            {step === 3 ? <CheckCircle2 className="h-5 w-5 text-emerald-500" /> :
              step === 2 ? <KeyRound className="h-5 w-5 text-primary" /> :
              <Mail className="h-5 w-5 text-primary" />}
          </div>
          <div>
            <h1 className="text-2xl font-black tracking-tighter font-display">
              {step === 3 ? "Mot de passe mis à jour" : step === 2 ? "Nouveau mot de passe" : "Mot de passe oublié"}
            </h1>
            <p className="text-xs text-muted-foreground mt-0.5">
              {step === 3 ? "Vous pouvez maintenant vous connecter." :
                step === 2 ? "Choisissez un mot de passe solide." :
                "Indiquez votre email pour recevoir un lien."}
            </p>
          </div>
        </div>

        {step === 1 && (
          <form onSubmit={request} className="space-y-4 border border-border rounded-2xl p-6 bg-card" data-testid="reset-request-form">
            <div className="space-y-2">
              <Label className="text-xs uppercase tracking-wider font-bold">Email</Label>
              <Input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="rounded-md h-11" placeholder="vous@exemple.fr" data-testid="reset-email-input" />
            </div>
            <Button disabled={loading} className="w-full rounded-full h-11 btn-glow" data-testid="reset-request-btn">
              {loading ? "Envoi…" : "Envoyer le lien"}
            </Button>
          </form>
        )}
        {step === 2 && (
          <form onSubmit={confirm} className="space-y-4 border border-border rounded-2xl p-6 bg-card" data-testid="reset-confirm-form">
            <p className="text-xs text-muted-foreground">Token (auto-rempli en démo)</p>
            <Input value={token} onChange={(e)=>setToken(e.target.value)} className="rounded-md h-11 font-mono text-xs" data-testid="reset-token-input" />
            <div className="space-y-2">
              <Label className="text-xs uppercase tracking-wider font-bold">Nouveau mot de passe</Label>
              <Input type="password" required value={pwd} onChange={(e)=>setPwd(e.target.value)} minLength={6} className="rounded-md h-11" data-testid="reset-newpwd-input" />
            </div>
            <Button disabled={loading} className="w-full rounded-full h-11 btn-glow" data-testid="reset-confirm-btn">
              {loading ? "…" : "Mettre à jour"}
            </Button>
          </form>
        )}
        {step === 3 && (
          <div className="border border-border rounded-2xl p-6 bg-card text-sm" data-testid="reset-success">
            <p className="text-muted-foreground">Tout est en ordre.</p>
            <Link to="/login"><Button className="w-full mt-4 rounded-full h-11 btn-glow">Se connecter</Button></Link>
          </div>
        )}
        <Link to="/login" className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors">
          <ArrowLeft className="h-3.5 w-3.5 mr-1.5" />Retour à la connexion
        </Link>
      </div>
    </div>
  );
}
